import { gql } from "@apollo/client";

export const RESET_PASSWORD_MUTATION = gql`
  mutation SendResetPasswordEmail($data: ResetPasswordMailInput!) {
    sendResetPasswordEmail(data: $data)
  }
`;
